module.exports = __webpack_public_path__ + "files/bf84244fa360c5536855bd84e8a847ae.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bolditalic-webfont.svg
 ** module id = 1014
 ** module chunks = 0
 **/